import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PRODUCTION_APIS, IMPLEMENTATIE_STAPPEN } from '@/constants/laadplein-data';

const PRIORITY_COLORS: Record<string, string> = {
  kritiek: "bg-red-100 text-red-700",
  hoog: "bg-amber-100 text-amber-700",
  medium: "bg-blue-100 text-blue-700",
  laag: "bg-gray-100 text-gray-600",
};

const DOT_COLORS: Record<string, string> = {
  kritiek: "bg-red-400",
  hoog: "bg-amber-400",
  medium: "bg-blue-400",
  doel: "bg-emerald-400",
};

export function RoadmapTab() {
  const [filter, setFilter] = useState('alle');
  const filtered = filter === 'alle' ? PRODUCTION_APIS : PRODUCTION_APIS.filter(a => a.prioriteit === filter);

  return (
    <div>
      <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-6">
        <div className="text-sm font-medium text-emerald-800 mb-1">Van demo naar productie</div>
        <div className="text-xs text-emerald-700">
          Deze module gebruikt hardcoded data op basis van openbare bronnen. Hieronder staat precies welke API's en databronnen je moet aansluiten om live, actuele data te krijgen. Elke bron bevat de exacte integratie-aanpak voor jouw n8n + Supabase stack.
        </div>
      </div>

      <div className="flex gap-1 mb-4 flex-wrap">
        {['alle', 'kritiek', 'hoog', 'medium', 'laag'].map(f => (
          <Button
            key={f}
            variant="ghost"
            size="sm"
            onClick={() => setFilter(f)}
            className={filter === f ? 'bg-emerald-100 text-emerald-700 font-medium' : 'text-gray-400'}
          >
            {f} ({f === 'alle' ? PRODUCTION_APIS.length : PRODUCTION_APIS.filter(a => a.prioriteit === f).length})
          </Button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered.map((api, i) => (
          <Card key={i}>
            <CardContent className="p-4">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <div className="font-semibold text-sm">{api.naam}</div>
                  <div className="text-xs text-blue-500">{api.url}</div>
                </div>
                <div className="flex gap-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${PRIORITY_COLORS[api.prioriteit] || ''}`}>
                    {api.prioriteit}
                  </span>
                  <span className={`text-xs px-2 py-0.5 rounded-full ${api.status === "beschikbaar" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>
                    {api.status}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">{api.kosten}</span>
                </div>
              </div>
              <div className="text-xs text-gray-600 mb-2">{api.data}</div>
              <div className="bg-gray-50 rounded-lg p-2.5">
                <div className="text-xs font-medium text-gray-500 mb-1">Integratie-aanpak:</div>
                <div className="text-xs text-gray-700 font-mono">{api.integratie}</div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="mt-6">
        <CardContent className="p-4">
          <div className="text-sm font-medium text-gray-700 mb-3">Implementatievolgorde</div>
          <div className="space-y-2">
            {IMPLEMENTATIE_STAPPEN.map((s, i) => (
              <div key={i} className="flex items-center gap-3 text-xs">
                <span className="w-16 text-gray-400 font-medium">{s.week}</span>
                <span className={`w-2 h-2 rounded-full flex-shrink-0 ${DOT_COLORS[s.prioriteit] || "bg-gray-400"}`} />
                <span className="text-gray-700">{s.taak}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
